export default __webpack_public_path__ + "static/media/codeforces.39f8901f.jpg";